import { render, staticRenderFns } from "./GroupTemplates.vue?vue&type=template&id=69bfdfe9&"
import script from "./GroupTemplates.vue?vue&type=script&lang=js&"
export * from "./GroupTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports